<template>
    <div>
         <!--product details start-->
        <div class="product_details pt-30">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="product-details-tab">
                                <lingallery :iid.sync="currentImageId" :responsive="true" :items="galary_images"/>
                                <!-- <div id="img-1" class="zoomWrapper single-zoom">
                                    <a href="#">
                                        <img id="zoom1" :src="'/'+currentItem.path" :data-zoom-image="'/'+currentItem.path" alt="big-1">
                                    </a>
                                </div>

                                <div class="single-zoom-thumb" v-if="currentItem.additional_images">
                                    <ul class="s-tab-zoom owl-carousel single-product-active" id="gallery_01">
                                        <li>
                                            <a href="#" class="elevatezoom-gallery" data-update="" :data-image="'/'+currentItem.path" :data-zoom-image="'/'+currentItem.path">
                                                <img :src="'/'+currentItem.path" alt="additional_image"/>
                                            </a>
                                        </li>
                                        <li v-for="(additional_image,index) in currentItem.additional_images" :key="index">
                                            <a href="#" class="elevatezoom-gallery" data-update="" :data-image="'/'+additional_image.path" :data-zoom-image="'/'+additional_image.path">
                                                <img :src="'/'+additional_image.path" :alt="'additional_image'+index"/>
                                            </a>
                                        </li>
                                    </ul>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="product_d_right">
                                    <h1>{{ currentItem.name }}</h1>
                                    <!-- <div class="product_nav">
                                        <ul>
                                            <li class="prev"><a href="#"><i class="fa fa-angle-left"></i></a></li>
                                            <li class="next"><a href="#"><i class="fa fa-angle-right"></i></a></li>
                                        </ul>
                                    </div> -->
                                    <div class="product_code">
                                        <p>Mã sản phẩm: <b>{{ currentItem.product_code }}</b></p>
                                        <p v-if="currentItem.made_in">Xuất xứ: <b>{{ currentItem.made_in }}</b></p>
                                        <p v-if="currentItem.unit_qty">Đơn vị tính: <b>{{ currentItem.unit_qty }}</b></p>
                                    </div>
                                    <div class="product_stock" v-if="currentItem.manage_stock">
                                    <p>Tồn kho: <b>{{ currentItem.qty | currency }}</b></p>
                                    </div>
                                    
                                    <div class="product_price">
                                        <!-- <span class="old_price">$80.00</span> -->
                                        <span class="current_price">{{ (is_retailer && currentItem.retail_price ? currentItem.retail_price : currentItem.price) | currency }}</span>
                                    </div>
                                    <div class="product_option" v-if="currentItem.options">
                                        <v-layout row wrap v-for="op in currentItem.options" :key="op.id">
                                            <v-flex lg4 md4 sm12>
                                                <h4>{{ op.name }}</h4>
                                            </v-flex>
                                            <v-flex lg8 md8 sm12 v-if="op.position == 0">
                                                <ul class="list-inline-1">
                                                    <li v-for="val in op.option_values" :key="val.id" v-bind:class="{ 'has_image': op.has_image && val.path, 'active': val.id == selectedFirstOption.id, 'choised': getFirstOptionQty(val.id) > 0}"  @click="selectedFirstOption = val">
                                                        <img :src="'/'+val.path" alt="Option image" v-if="op.has_image && val.path" @click="showImageFigure('/'+val.path)">
                                                        <p v-else>{{ val.label }}</p>
                                                    </li>
                                                </ul>
                                            </v-flex>
                                            <v-flex lg8 md8 sm12 v-else>
                                                <ul class="list-inline-2">
                                                    <li v-for="val in op.option_values" :key="val.id" class="number-picker" v-bind:class="{'choised': getOrderOption(selectedFirstOption.id, val.id) > 0}">
                                                        <label for="qty">{{ (selectedFirstOption ? selectedFirstOption.label + ' - ' : '') + val.label }}</label>
                                                        <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, val.id)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, val.option_id, val.id, event)"></v-minusplusfield>
                                                    </li>
                                                </ul>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap v-if="currentItem.options.length == 1 && selectedFirstOption">
                                            <v-flex lg4 md4 sm12>
                                            </v-flex>
                                            <v-flex lg8 md8 sm12>
                                                <ul class="list-inline-2">
                                                    <li class="number-picker single">
                                                        <label for="qty">{{ selectedFirstOption.label }}</label>
                                                        <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, 0)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event)"></v-minusplusfield>
                                                    </li>
                                                </ul>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                    <div class="product_desc">
                                        <v-textarea label="Ghi chú đơn hàng" v-model="order_note" class="input-group--focused" rows="3"></v-textarea>
                                    </div>
                                    <div class="product_variant quantity">
                                        <label>Tổng số lượng</label>
                                        <input type="number" :value="totalQty" v-if="currentItem.options && currentItem.options.length > 0" disabled>
                                        <v-minusplusfield v-else :min="0" :max="1000000" :value="totalQty" @input="event => updateOrderOption(0, 0, 0, 0, event)"></v-minusplusfield>
                                        
                                        <button class="button" type="submit" v-if="!isAuthenticated" @click="placeOrder">Đăng nhập để mua hàng</button>
                                        <button class="button" type="submit" v-else-if="currentItem.is_active" @click="placeOrder">Mua ngay</button>
                                        <button class="button button-disabled" type="submit" v-else>Dừng mua</button>
                                    </div>
                                    <div class="product_meta">
                                        <!-- <span>Danh mục: <a href="#">Clothing</a></span> -->
                                    </div>
                                <div class="priduct_social">
                                    <ul>
                                        <li><a href="#" title="facebook"><i class="fa fa-facebook"></i></a></li>           
                                        <li><a href="#" title="twitter"><i class="fa fa-twitter"></i></a></li>           
                                        <li><a href="#" title="pinterest"><i class="fa fa-pinterest"></i></a></li>           
                                        <li><a href="#" title="google +"><i class="fa fa-google-plus"></i></a></li>        
                                        <li><a href="#" title="linkedin"><i class="fa fa-linkedin"></i></a></li>        
                                    </ul>      
                                </div>

                            </div>
                        </div>
                    </div>
                </div>    
        </div>
        <!--product details end-->

        <!--product info start-->
        <div class="product_d_info">
            <div class="container">   
                <div class="row">
                    <div class="col-12">
                        <div class="product_d_inner">   
                            <div class="product_info_button">    
                                <ul class="nav" role="tablist">
                                    <li >
                                        <a class="active" data-bs-toggle="tab" href="#info" role="tab" aria-bs-controls="info" aria-selected="false">Mô tả</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane fade show active" id="info" role="tabpanel" >
                                    <div class="product_info_content">
                                        <p v-html="currentItem.description"></p>
                                    </div>    
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
            </div>    
        </div>  
        <!--product info end-->
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Vue from 'vue';
import { sendErrorNotice, showImageFigure, loadingData } from '@/commons/utils'
import PlusMinusField from "@/components/PlusMinusField.vue";
import _ from 'lodash';
export default {
    name: "product-detail",
    components: {
        'v-minusplusfield': PlusMinusField
    },
    setup() {
        return {
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: []
        }
    },
    data() {
        return {
            order_note: '',
            selectedFirstOption: {},
            order_options: [],
            currentImageId: null,
            is_creating: false,
            showImageFigure: showImageFigure
        }
    },
    computed: {
        ...mapState({
            currentItem: state => state.products.selected,
            loading: state => state.products.loading
        }),
        isAuthenticated() {
            return localStorage.getItem('jwt') !== null;
        },
        currentId() {
            return this.$route.params.Pid;
        },
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        totalQty() {
            return _.sumBy(this.order_options, "value");
        },
        galary_images() {
            let tmp = [{id: this.currentItem.path, src: `/${this.currentItem.path}`, thumbnail: `/${this.currentItem.path}`}];
            if(this.currentItem.additional_images) {
                let additional_images = _.map(this.currentItem.additional_images, (p) => {return {id: p.path, src: `/${p.path}`, thumbnail: `/${p.path}`}});
                tmp = tmp.concat(additional_images);
            }
            tmp = _.uniqBy(tmp, function (e) {return e.id;});
            return tmp;
        },
        is_retailer() {
            return this.$store.state.authentication.user.retailer;
        },
    },
    watch: {
        currentId() {
            this.refreshData();
        },
        loading(){
            if(!this.loading) {
                Vue.nextTick(() => {
                    document.title = this.currentItem ? this.currentItem.name + ' | ' + configs.DEFAULT_TITLE : configs.DEFAULT_TITLE;
                });
            }
        },
        currentItem() {
            if (this.currentItem) {
                this.selectedFirstOption = this.currentItem.options && this.currentItem.options.length > 0 ? this.currentItem.options[0].option_values[0] : {};
            }
        }
    },
    methods: {
        refreshData() {
            if(Number(this.currentId) > 0) {
                this.$store.dispatch("products/getDetail", this.currentId);
                this.order_note = '';
                this.selectedFirstOption = {};
                this.order_options = [];
            }            
        },
        updateOrderOption(first_op_id, first_opvl_id, last_op_id, last_opvl_id, value) {
            let item = _.find(this.order_options, {'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id });
            if (item) {
                item['value'] = Number(value);
            }
            else {
                this.order_options.push({'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id , 'value': Number(value) });
            }
        },
        getOrderOption(first_id, last_id) {
            let item = _.find(this.order_options, {'first_id': first_id, 'last_id': last_id });
            return item ? item.value : 0;
        },
        getFirstOptionQty(first_id) {
            return _.sumBy(this.order_options, (p) => {return p.first_id == first_id ? p.value : 0});
        },
        placeOrder: _.debounce(function () {
            if(this.is_creating) {
                return;
            }
            if(!this.isAuthenticated) {
                window.getApp.$router.replace('/dang-nhap');
                return;
            }
            if(this.totalQty == 0) {
                sendErrorNotice('Hãy chọn số lượng sản phẩm cần mua.');
                return;
            }
            this.$store.dispatch("products/getDetail", this.currentItem.id).then((ret) => {
                if (ret.is_active) {
                    this.is_creating = true;
                    loadingData(this.is_creating);
                    this.$store.dispatch("orders/setDetail", {data:{
                        product_id: this.currentItem.id,
                        qty: this.totalQty,
                        price: this.is_retailer && this.currentItem.retail_price ? this.currentItem.retail_price : this.currentItem.price,
                        order_note: this.order_note,
                        multipleOptions: _.filter(this.order_options, (p) => { return p.value > 0}),
                        sub_total: this.totalQty * this.currentItem.price,
                        total: this.totalQty * this.currentItem.price,
                    }}).then((ret) => {this.is_creating = false; loadingData(this.is_creating); window.getApp.$router.push(`/dat-hang-thanh-cong/${ret.data.id}`);});
                }
                else {
                    sendErrorNotice('Sản phẩm đã dừng mua.');
                    return;
                }
            });
        }, 1000, {'leading': true})
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>